import _ from 'lodash';

import { tours } from '../../api/api'

export const FETCH_TOURS_BEGIN   = 'FETCH_TOURS_BEGIN'
export const FETCH_TOURS_SUCCESS = 'FETCH_TOURS_SUCCESS'
export const FETCH_TOURS_ERROR = 'FETCH_TOURS_ERROR'

export const fetchTours = () => (dispatch, getState) => {
  dispatch({ type: FETCH_TOURS_BEGIN })
  const brand = _.get(getState(), 'configurationData.data.brand')
  const tourIds = _.get(getState(), 'configurationData.data.tourIds')
  return tours(brand, tourIds)
    .then(response => {
      // tours come back from the api in a different order than requested,
      // so we need to sort the response based on the initial id list
      const tourIdList = _.split(tourIds, ',')
      const orderedTours = _.reduce(tourIdList, (orderedList, tourId) => {
        const tour = _.find(response, item => item.id === tourId)
        return tour ? _.concat(orderedList, tour) : orderedList
      }, [])
      dispatch({ type: FETCH_TOURS_SUCCESS, payload: orderedTours })
    })
    .catch(error => dispatch({ type: FETCH_TOURS_ERROR, payload: true }))
}
